import React, { useContext, useEffect, useState } from "react";
import { Modal, Alert, Table } from "react-bootstrap";

import PortalService from '../../../services/portal.service';
import StateContext from '../../../context/State';
import { SourceOfFunds, ClientPortalModalType } from "../../../types";
import { useAppSelector } from "../../../../../redux/hooks";
import { ReducerEnum, setClientPortalModalType } from "../../../../../redux/reducer";


export type SourceOfFundsTaskModalProps = {
    dispatch: (arg0: {
        type: ReducerEnum;
        payload: any;
        key?: string;
        extraPayload?: Record<string, string>;
    }) => void;
}

const SourceOfFundsTaskModal = (props: SourceOfFundsTaskModalProps) => {
    
    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);

    const show: boolean = useAppSelector((state) => state.ClientPortalState?.ModalType === ClientPortalModalType.SOURCE_OF_FUNDS);

    const [sourceOfFunds, setSourceOfFunds] = useState<SourceOfFunds[]>([]);

    // eslint-disable-next-line
    useEffect(() => { getSourceOfFunds() }, [])

    const getSourceOfFunds = async () => {
        try {
            const response: SourceOfFunds[] = await portalService.getSourceOfFunds(state.portalId);
            setSourceOfFunds(response);
        } catch (e) {
            console.log('Unable to get Source Of Funds: ', e);
        }
    }

    return (
        <>
            <Modal
                show={show}
                onHide={() => {props.dispatch(setClientPortalModalType(ClientPortalModalType.NONE))}}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="modal-list"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Source of Funds</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {sourceOfFunds.length !== 0 ?
                        <Table>
                            <thead>
                                <tr>
                                    <th>Provider Name</th>
                                    <th>Amount</th>
                                    <th>Source</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    sourceOfFunds.map((source: SourceOfFunds) => {
                                        return (
                                            <React.Fragment key={source.Source + '-source-item'}>
                                                <tr>
                                                    <td>{source.LenderName}</td>
                                                    <td>{source.Amount}</td>
                                                    <td>{source.Source}</td> 
                                                </tr>
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                        :
                        <Alert style={{margin:"20px"}}>Source of Funds has not yet been submitted.</Alert>
                    }
                </Modal.Body>
            </Modal>
        </>
    );
}

export default SourceOfFundsTaskModal;
